"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteUserUseCase = void 0;
const users_1 = require("@/services/users");
const users_2 = require("@/store/ducks/users");
function deleteUserUseCase(userId) {
    return async (dispatch) => {
        dispatch((0, users_2.deleteUser)());
        try {
            await (0, users_1.deleteUser)(userId);
            dispatch((0, users_2.deleteUserSuccess)(userId));
            dispatch((0, users_2.openUserToast)({
                status: "success",
                message: "User removed successfully.",
            }));
        }
        catch (error) {
            dispatch((0, users_2.deleteUserError)("Error while deleting user"));
            return Promise.reject();
        }
    };
}
exports.deleteUserUseCase = deleteUserUseCase;
